// extracted by mini-css-extract-plugin
var _1 = "DocFlowMappingRecipientModalPanel-moduleDocFlowMappingRecipientModalPanel__RX69j";
var _2 = "DocFlowMappingRecipientModalPanel-modulecontent__mwuoA";
var _3 = "DocFlowMappingRecipientModalPanel-moduledivider__nVkhP Divider-moduleDivider__dL3Vg";
var _4 = "DocFlowMappingRecipientModalPanel-moduleerror__uR142";
var _5 = "DocFlowMappingRecipientModalPanel-modulefile__ndMgm FileMultiValue-moduleFileMultiValue__T4C7d";
var _6 = "DocFlowMappingRecipientModalPanel-modulefileName__c2HVc";
var _7 = "DocFlowMappingRecipientModalPanel-modulefooter___1llf";
export { _1 as "DocFlowMappingRecipientModalPanel", _2 as "content", _3 as "divider", _4 as "error", _5 as "file", _6 as "fileName", _7 as "footer" }
